import { ReactNode } from 'react';
import { Box } from '@mui/material';

// ==============================|| ANIMATION BUTTON ||============================== //
// เดิมใช้ framer-motion — ทำให้ `next build` ล้มตอน collecting page data (useCallback null ใน worker SSR)
// ใช้ CSS transform แทน พฤติกรรม hover/tap ใกล้เคียงเดิม

export type ScaleProps = {
  hover: number | string | undefined;
  tap: number | string | undefined;
};

export interface Props {
  children?: ReactNode;
  type?: 'slide' | 'scale' | 'rotate';
  direction?: 'up' | 'down' | 'left' | 'right';
  offset?: number;
  scale?: ScaleProps;
}

export default function AnimateButton({
  children,
  type = 'scale',
  direction = 'right',
  offset = 10,
  scale
}: Props) {
  const s =
    typeof scale === 'number'
      ? { hover: scale, tap: scale }
      : scale ?? { hover: 1.05, tap: 0.95 };

  const hover = typeof s.hover === 'number' ? s.hover : 1.05;
  const tap = typeof s.tap === 'number' ? s.tap : 0.95;

  if (type === 'rotate') {
    return (
      <Box
        sx={{
          display: 'inline-block',
          animation: 'spin 2s linear infinite',
          '@keyframes spin': {
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(360deg)' }
          }
        }}
      >
        {children}
      </Box>
    );
  }

  if (type === 'slide') {
    const off = offset ?? 10;
    const isVertical = direction === 'up' || direction === 'down';
    const hoverTransform = isVertical
      ? `translateY(${direction === 'up' ? -off : off}px)`
      : `translateX(${direction === 'left' ? -off : off}px)`;

    return (
      <Box
        sx={{
          display: 'inline-block',
          transition: 'transform 0.2s ease',
          '&:hover': { transform: hoverTransform }
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'inline-block',
        transition: 'transform 0.15s ease',
        '&:hover': { transform: `scale(${hover})` },
        '&:active': { transform: `scale(${tap})` }
      }}
    >
      {children}
    </Box>
  );
}
